export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_CART_NUM = 'SET_CART_NUM'
export const SET_SHOW_SEARCH = 'SET_SHOW_SEARCH'
export const SET_USER_REGISTERID = 'SET_USER_REGISTERID'
export const SET_LINKSRC = 'SET_LINKSRC'
export const SET_AVATAR = 'SET_AVATAR'
export const SET_ENTERTIME = 'SET_ENTERTIME'
export const SET_LEAVETIME = 'SET_LEAVETIME'
export const SET_KEYWORD = 'SET_KEYWORD'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js